import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CollectionsService } from '../../service/collections.service';
import { Observable, Subscription } from 'rxjs';
import { CollectionInterface } from '../../interfaces/collection.interface';
import i18next from 'i18next';
import { take } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { CartService } from 'src/modules/cart/services/cart.service';
import { NativeIntegrationService } from 'src/core/services/native-integration.service';
import { BatchProductInterface } from 'src/modules/cart/interfaces/cart.interface';

@Component({
  selector: 'app-collection-detail',
  templateUrl: './collection-detail.component.html',
  styleUrls: ['./collection-detail.component.scss']
})
export class CollectionDetailComponent implements OnInit {
  collectionId: string;
  collection!: CollectionInterface;
  collectionData!: CollectionInterface[];
  productNumber!: number;
  dataLoaded = this.collectionsService.dataLoaded;

  private subscriptions: Subscription = new Subscription();

  constructor(
    private activatedRoute: ActivatedRoute,
    public collectionsService: CollectionsService,
    private toastr: ToastrService,
    private cartService: CartService,
    private nis: NativeIntegrationService
  ) {
    this.collectionId = this.activatedRoute.snapshot.params.id;
    const collectionDataSub = this.collectionsService.loadDataObservable$.subscribe(() => {
      this.dataLoaded = true;
      this.serveData();
    });
    this.subscriptions.add(collectionDataSub);
  }

  ngOnInit(): void {
    if (this.dataLoaded) {
      this.serveData();
    }
  }

  serveData(): void {
    this.collection = this.collectionsService.getCollectionData(this.collectionId);
    console.log(this.collectionsService.getCollectionData(this.collectionId));
    this.productNumber = this.collectionsService.getProductCountFromCollection(this.collectionId);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  addCollectionToBagPressed(): void {
    console.log('addition is starting...');
    const addAllToBagSub = this.addCollectionToBag().subscribe({
      complete: () => {
        console.log('addition is done');
        const toastAddSub = this.toastr.info(i18next.t('add-to-cart.add-all-products')).onTap
          .pipe(take(1))
          .subscribe(() => this.openCart());
        this.subscriptions.add(toastAddSub);
      }
    });
    this.subscriptions.add(addAllToBagSub);
  }

  addCollectionToBag(): Observable<any> {
    return new Observable<any>(subscriber => {
      const data: BatchProductInterface[] = [];
      const products = this.collectionsService.getProductsDataFromCollection(this.collection.id.toString());
      for (let i = 0; i < products.length; i++) {
        data.push({ product: products[i], collectionId: this.collection.id.toString(), quantity: 1 })
      }
      this.cartService.batchAddToCart(data);

      subscriber.complete();
    });
  }

  openCart(): void {
    this.cartService.cartOpen$.next(true);
    this.nis.hapticFeedbackClick();
  }
}
